<template>
    <div>
    	
    	<table>
    		<tr v-for="(item,index) in datas" :key="index" v-if="item != ''">
    			<td style="width:150px" :class="index==0?'theme-col':'default-col'">{{item.time}}</td>
    			<td style="position:relative;width:100px;">
    				<div style="height:100%"></div>
    				<div class="circle" :class="index==0?'theme-bg first-circle':true"></div>
    				<div class="line" v-if="index != datas.length-1"></div>
    				<div class="tline line" v-if="index!=0"></div>
    			</td>
    			<td :class="index==0?'theme-col':'default-col'">{{item.context}}</td>
    		</tr>
    	</table>
    	<div v-if="datas == null" style="padding:20px 0px;text-align:center;">
            暂无物流信息
          </div>
    </div>
</template>

<script >
export default{
	name:"",
	props:{
		datas:'',
		nodata:''
	}
}
</script>

<style lang="less" scoped>
td{
	padding:10px 0px;
}
.circle{
	width:10px;
	height:10px;
	border-radius:10px;
	position:absolute;
	top: 50%;
	left:50%;
	transform: translate(-50%,-50%);
	background:#E5E6E8;
	z-index:2;
}
.line{
	position:absolute;
	left:50%;
	height:50%;
	transform: translateX(-50%);
	background:#E5E6E8;
	width:2px;
	z-index:1;
}
.first-circle{
	border:2px solid #FCC1BE;
}
.tline{
	top:0px;
}
.default-col{
	color:#565656;
}
</style>



// WEBPACK FOOTER //
// src/common/timeline.vue